<mat-card appearance="outlined">

  <mat-list>
    <mat-list-item>Entrance type</mat-list-item>
    <mat-list-item class="dynamic-content-types">
      <mat-radio-group [(ngModel)]="entranceType">
        <mat-radio-button *ngFor="let type of entranceTypes" [value]="type.value"
                          class="dynamic-content-type">{{type.title}}</mat-radio-button>
      </mat-radio-group>
    </mat-list-item>

    <mat-list-item *ngIf="customer">
      <span>Assigned Customer: {{customer}}</span>
    </mat-list-item>

    <mat-list-item>
      <mat-checkbox (change)="removeCustomer($event)">Assign no customer</mat-checkbox>
    </mat-list-item>

    <mat-list-item>
      <mat-checkbox [(ngModel)]="readonly">Read Only</mat-checkbox>
    </mat-list-item>

    <mat-list-item *ngIf="entranceType === 'person' || entranceType === 'activity'">
      <mat-checkbox [(ngModel)]="noCategories">No Categories</mat-checkbox>
    </mat-list-item>
  </mat-list>

  <mat-expansion-panel *ngIf="!!data" class="code-area">
    <mat-expansion-panel-header>
      <mat-panel-title>Configuration</mat-panel-title>
      <mat-panel-description>Expand to edit</mat-panel-description>
    </mat-expansion-panel-header>
    <code-area [options]="{ maxLines: 30, minLines: 20, fontSize: '16px', autoScrollEditorIntoView: true }" [parent]="data"
                   [value]="data.config" key="config" type="json"></code-area>
  </mat-expansion-panel>

</mat-card>

<div class="button-right-container">
  <button (click)="assignCustomer()" *ngIf="customerType" class="ibexfusion-raised-button" mat-button>assign customer</button>
  <button (click)="assignOrganisation()" *ngIf="customerType" class="ibexfusion-raised-button" mat-button>child organisation</button>
  <button (click)="save()" *ngIf="!customerType" class="ibexfusion-raised-button" mat-button>
    Save without assigned customer?
  </button>
  <button (click)="save()" *ngIf="customerType && selectedCustomerId" class="ibexfusion-raised-button" mat-button>
    save
  </button>
</div>

